import { ClassAverages } from 'models/TeacherGradebook';

export default class DistrictGradebook {
  public entries: Record<string, ClassAverages>;
  public averages: ClassAverages;

  constructor(entries: Record<string, ClassAverages>, averages: ClassAverages) {
    this.entries = entries;
    this.averages = averages;
  }

  static fromDistrictGradebook(district: DistrictGradebook) {
    return new DistrictGradebook(district.entries, district.averages);
  }

  static fromServerDistrictGradebook(
    serverGradebook: Record<string, any>,
  ): DistrictGradebook {
    return new DistrictGradebook(
      serverGradebook['entries'],
      serverGradebook['averages'],
    );
  }

  public toJSON(): Record<string, any> {
    return {
      entries: this.entries,
      averages: this.averages,
    };
  }
}
